import React, { useEffect, useState } from "react";
import { Button, Grid, Paper, TextField, Typography } from "@material-ui/core";
import { api } from "../../api";
import { UserLogList } from "./UserLogView/UserLogList";
import { useUserLogStyles } from "./useUserLogStyles";
import { Formik, Form, ErrorMessage } from "formik";
import { Helmet } from "react-helmet-async";
import * as yup from "yup";
import moment from "moment";
import { useStore } from "../../store";

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const UserLogMaster = () => {
  const [userLogData, setUserLogData] = useState<Array<Object> | void>();
  const [storeDetails] = useStore("storeDetails");
  const [storeusers] = useStore("users");
  const classes = useUserLogStyles();
  var currentDate = new Date();
  const to_date = moment(currentDate).format("YYYY-MM-DD");
  const from_date = moment(currentDate).format("YYYY-MM-DD");
  const store_id = storeDetails?.id;
  const today = moment(currentDate).format("YYYY-MM-DD");
  const [value, setValue] = React.useState(0);
  //const [editData, setEditData] = useState<object>({});
  //const [editFlag, setEditFlag] = useState<boolean>(false);
  const [viewUserLogPermission, setViewUserLogPermission] = useState<boolean>(
    false
  );
  const [editUserLogPermission, setEditUserLogPermission] = useState<boolean>(
    false
  );
  const [addUserLogPermission, setAddUserLogPermission] = useState<boolean>(
    false
  );

  const [posConfigurations] = useStore("posConfigurations");
  const [user] = useStore("auth", "user");
  useEffect(() => {
    const userLogPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 22
    );
    if (user.is_super_admin === true) {
      setAddUserLogPermission(true);
      setEditUserLogPermission(true);
      setViewUserLogPermission(true);
    } else {
      if (userLogPermission) {
        if (userLogPermission.is_add === true) {
          setAddUserLogPermission(true);
        }
        if (userLogPermission.is_view === true) {
          setViewUserLogPermission(true);
        }
        if (userLogPermission.is_edit === true) {
          setEditUserLogPermission(true);
        }
        if (userLogPermission.is_view === false) {
          setValue(1);
          setViewUserLogPermission(false);
        }
        if (
          userLogPermission.is_add === false &&
          userLogPermission.is_edit === false &&
          userLogPermission.is_view === false
        ) {
          setAddUserLogPermission(false);
          setEditUserLogPermission(false);
          setViewUserLogPermission(false);
        }
      }
    }
    {
      if (viewUserLogPermission) {
        getUserLogData(today, null);
      }
    }
  }, []);

  const getUserLogData = async (
    today: string | undefined,
    to_date: string | null
  ) => {
    if (viewUserLogPermission) {
      const payload = {
        from_date: today,
        to_date: to_date,
      };

      const resultData = await api.post(`stores/${store_id}/log`, {}, payload);
      setUserLogData(resultData);
    }
  };

  return (
    <>
      <Helmet>
        <title>User logs</title>
      </Helmet>
      <div className={classes.root}>
        <Paper elevation={2} className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Formik
                enableReinitialize
                initialValues={{
                  fromDate: from_date,
                  toDate: to_date,
                  todaysDate: today,
                }}
                validationSchema={yup.object().shape({
                  fromDate: yup.date().required("Required"),
                })}
                onSubmit={async (values) => {
                  getUserLogData(values.fromDate, values.toDate);
                }}
              >
                {({ values, handleChange }) => (
                  <Form>
                    <Grid
                      container
                      direction="row"
                      spacing={3}
                      style={{
                        paddingLeft: "2em",
                        paddingRight: "2em",
                        paddingTop: "2em",
                      }}
                    >
                      <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            getUserLogData(today, null);
                          }}
                        >
                          Current Day
                        </Button>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container direction="column">
                          <Typography
                            style={{ textAlign: "left", fontWeight: "bold" }}
                          >
                            From Date
                          </Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            onChange={handleChange}
                            value={values.fromDate}
                          />
                          <ErrorMessage name="fromDate">
                            {(msg) => (
                              <div
                                className={classes.textFieldErrorMessageStyle}
                              >
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>

                      <Grid item xs={3}>
                        <Grid container direction="column">
                          <Typography
                            style={{ textAlign: "left", fontWeight: "bold" }}
                          >
                            To Date
                          </Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            onChange={handleChange}
                            value={values.toDate}
                          />
                          <ErrorMessage name="toDate">
                            {(msg) => (
                              <div
                                className={classes.textFieldErrorMessageStyle}
                              >
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>
                      <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                        >
                          Show List
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginLeft: "2em", marginRight: "2em" }}
            >
              <UserLogList users={userLogData} storeusers={storeusers} />
            </Grid>
          </Grid>
        </Paper>
      </div>
    </>
  );
};
